import useWindowWidth from "@Helpers/useWindowWidth";
import { Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
const TruncatedText = ({ children, ...typographyProps }) => {
    const textReference = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    const width = useWindowWidth();
    // Check if the text is truncated
    useEffect(() => {
        const element = textReference.current;
        if (element) {
            const isSingleLine = getComputedStyle(element).whiteSpace === "nowrap";
            const truncated = isSingleLine
                ? element.scrollWidth > element.clientWidth
                : element.scrollHeight > element.clientHeight;
            setIsTruncated(truncated);
        }
    }, [children, width]);
    return (React.createElement(Tooltip, { title: isTruncated ? children : "", arrow: true, disableHoverListener: !isTruncated },
        React.createElement(Typography, { ref: textReference, noWrap: true, ...typographyProps, sx: { width: "100%", display: "block", ...typographyProps.sx } }, children)));
};
export default TruncatedText;
